"use client";
import { OffersSection } from "@/components/sections/OffersSection";
import { EquipmentsSection } from "@/components/sections/EquipmentsSection";
import { BannerSection } from "@/components/sections/BannerSection";
import { BreadcrumbHomepage } from "@/components/sections/BreadcrumbHomepage";
import { ContactSection } from "@/(landing-page)/sections/ContactSection";
import { Suspense } from "react";

export default function Offres() {
  return (
    <main>
      <BannerSection title="Offres" />
      <BreadcrumbHomepage />
      <OffersSection />
      <Suspense fallback={null}>
        <ContactSection />
      </Suspense>
      <EquipmentsSection />
    </main>
  );
}
